// 公共流程展示逻辑mixin，适用于PC端和钉钉端
import {
  formateValue,
  splitPropsParams,
  processFormData,
  flattenTree,
  computedTimeSpent,
  setFormValue,
  flattenSpanLayoutFields
} from '@/components/approval/approvalUtil'
// import { postAction } from '@/api/manage'
 // 信息表单处理配置（用于 processInformationFormByConfig 泛化方法）
// ============================================================
const INFORMATION_FORM_CONFIGS = [
  {
    fieldPrefix: 'DocumentInformationForm_',
    componentNames: ['DocumentInformationForm', 'DocumentInformationNewForm'],
    groupFormId: 'DocumentInformationForm_groupForm',
    bizAlias: 'DocumentInformationGroup',
    summaryLabel: '文档资料',
    // 文档类型由组件名称动态决定
    getDocumentTypes(componentName, vm) {
      if (componentName === 'DocumentInformationForm') {
        return vm.documentTypes
      } else if (componentName === 'DocumentInformationNewForm') {
        return [
          { id: 'DocumentInformationForm_smallBatchGuide', name: '小批指导文档' },
          { id: 'DocumentInformationForm_manualCalibration', name: '手动校表流程说明' },
          { id: 'DocumentInformationForm_rtcCalibration', name: 'RTC校准说明' },
          { id: 'DocumentInformationForm_firmwareBurning', name: '固件烧写说明' },
          { id: 'DocumentInformationForm_factoryParamList', name: '出厂参数补充列表' },
          { id: 'DocumentInformationForm_firmwareQualityReport', name: '固件质量管控表交叉验证报告' }
        ]
      }
      return []
    }
  },
  {
    fieldPrefix: 'SaleInformationForm_',
    componentNames: ['SaleInformationForm'],
    groupFormId: 'SaleInformationForm_groupForm',
    bizAlias: 'SaleInformationGroup',
    summaryLabel: '销售信息文档',
    getDocumentTypes() {
      return [
        { id: 'SaleInformationForm_factoryPlanDoc', name: '出厂方案配置文档' }
      ]
    }
  },
  {
    fieldPrefix: 'FunctionalTestingInformationForm_',
    componentNames: ['FunctionalTestingInformationForm'],
    groupFormId: 'FunctionalTestingInformationForm_groupForm',
    bizAlias: 'FunctionalTestingInformationGroup',
    summaryLabel: '功能测试信息文档',
    getDocumentTypes() {
      return [
        { id: 'FunctionalTestingInformationForm_factoryVerifyReport', name: '出厂方案验证报告' },
        { id: 'FunctionalTestingInformationForm_firmwareTestReport', name: '固件测试报告' }
      ]
    }
  }
]

// ============================================================
// 金额关键词（用于判断字段是否为金额字段）
// ============================================================
const AMOUNT_KEYWORDS = ['金额', '总额', '费用', '款项', '价格', '总计', '合计', '付款', '收款']

// ============================================================
// 文档组件类型与文档类型的映射关系
// ============================================================
function getDocumentTypesByComponentType(componentType, vm) {
  switch (componentType) {
    case 'DocumentInformationForm':
      return vm.documentTypes
    case 'DocumentInformationNewForm':
      return [
        { id: 'DocumentInformationForm_smallBatchGuide', name: '小批指导文档' },
        { id: 'DocumentInformationForm_manualCalibration', name: '手动校表流程说明' },
        { id: 'DocumentInformationForm_rtcCalibration', name: 'RTC校准说明' },
        { id: 'DocumentInformationForm_firmwareBurning', name: '固件烧写说明' },
        { id: 'DocumentInformationForm_factoryParamList', name: '出厂参数补充列表' },
        { id: 'DocumentInformationForm_firmwareQualityReport', name: '固件质量管控表交叉验证报告' }
      ]
    case 'SaleInformationForm':
      return [
        { id: 'SaleInformationForm_factoryPlanDoc', name: '出厂方案配置文档' }
      ]
    case 'FunctionalTestingInformationForm':
      return [
        { id: 'FunctionalTestingInformationForm_factoryVerifyReport', name: '出厂方案验证报告' },
        { id: 'FunctionalTestingInformationForm_firmwareTestReport', name: '固件测试报告' }
      ]
    default:
      return vm.documentTypes
  }
}

/**
 * 解析字段值为 { fileName, svnPath } 格式
 */
function parseFieldValue(fieldValue) {
  if (fieldValue && typeof fieldValue === 'object') {
    return { fileName: fieldValue.fileName || '', svnPath: fieldValue.svnPath || '' }
  } else if (typeof fieldValue === 'string') {
    try {
      const parsed = JSON.parse(fieldValue)
      return { fileName: parsed.fileName || '', svnPath: parsed.svnPath || '' }
    } catch (e) {
      return { fileName: '', svnPath: '' }
    }
  }
  return { fileName: '', svnPath: '' }
}

/**
 * 从 extValue 数组中解析文档详情
 */
function parseDocumentDetailsFromArray(extValue, documentTypes) {
  return documentTypes.map((docType) => {
    const docData = extValue.find((item) => item.id === docType.id)
    if (docData && docData.extValue) {
      try {
        const parsed = JSON.parse(docData.extValue)
        return {
          id: docType.id,
          name: docType.name,
          fileName: parsed.fileName || '',
          svnPath: parsed.svnPath || ''
        }
      } catch (e) {
        return { id: docType.id, name: docType.name, fileName: '', svnPath: '' }
      }
    }
    return { id: docType.id, name: docType.name, fileName: docData ? (docData.value || '') : '', svnPath: '' }
  })
}

export default {
  data() {
    return {
      loading: true,
      details: {},
      form: {
        taskId: null,
        comment: '',
        formData: {},
        variables: {}
      },
      processActionList: [],
      btnLoading: false,
      saveLoading: false,
      refuseLoading: false,
      argeeLoading: false,
      recordId: null,
      attachmentListAction: [],
      editableComponents: [],
      toProcessNodeList: [],
      processOriginNodeList: [],
      selfSelectMultiple: false,
      pickerType: 'user',
      dynamicAssigneeList: [],
      dynamicActiveNodeItems: [],
      activeSelectIndex: 0,
      nextApprovalNode: [],
      conditionNodeBranchs: [],
      fullApprovalActionList: [],
      orginVariables: {},
      conditionNodeChildren: [],
      sequenceFlowIds: [],
      selectedUserList: [],
      initailProcessList: [],
      excludeKeywords: Object.freeze([
        'MaterialForm',
        'ADMaterialGroupForm',
        'FirmwareInformationForm',
        'HardwareInformationForm',
        'SoftwareInformationForm',
        'StructuralInformationForm',
        'ProcessFileInformationForm',
        'SchemeChangeForm',
        'ParseFirmwareVersionForm',
        'ProjectCostDataForm',
        'FirmwarePartNumberReferenceForm',
        'FirmwarePartNumberCreateForm',
        'DocumentInformationForm',
        'DocumentInformationNewForm',
        'SaleInformationForm',
        'FunctionalTestingInformationForm'
      ])
    }
  },

  computed: {
    // ============================================================
    // 映射表（Map）
    // ============================================================
    categoryMap() {
      return Object.freeze({
        1: '固件',
        2: '硬件',
        3: '软件',
        4: '文档',
        5: '结构件',
        6: 'MES方案',
        21: 'PCB板子',
        22: 'BOM'
      })
    },
    softwareFileTypeMap() {
      return Object.freeze({
        '645': '645上位机',
        '698': '698上位机',
        internal: '挂网软件',
        dlmsUpgrade: 'dlms规约升级软件',
        otherUpgrade: '其他升级软件',
        project: '项目关联的上位机'
      })
    },
    itemFormAttributeMap() {
      return { '4': '委外加工件', '9': '采购件' }
    },
    itemMasterTypeMap() {
      return {
        '1': '贴片',
        '2': '插件',
        '3': '组装',
        '4': '包装',
        '5': '自动插件',
        '6': '通孔回流'
      }
    },
    countersignModeMap() {
      return { NEXT: '会签顺序', AND: '会签同时', OR: '或签' }
    },
    stateAction() {
      return {
        '-1': ['gray', '撤销', require('@/assets/oa/revoked.svg')],
        0: ['gray', '草稿', ''],
        1: ['blue', '审批中', require('@/assets/oa/approvaling.svg')],
        2: ['red', '审批驳回', require('@/assets/oa/refuse.svg')],
        3: ['green', '审批通过', require('@/assets/oa/approved.svg')],
        4: ['gray', '流程关闭', require('@/assets/oa/closed.svg')]
      }
    },
    // processActionImg() {
    //   return {
    //     withdraw: require('@/assets/oa/withdraw.svg'),
    //     delegate: require('@/assets/oa/delegate.svg'),
    //     dynamicAddAuditor: require('@/assets/oa/signature.svg'),
    //     rollback: require('@/assets/oa/rollback.svg')
    //   }
    // },

    // ============================================================
    // 权限/状态判断
    // ============================================================
    forbiddenReject() {
      return !!(this.details && this.details.variables && this.details.variables.forbiddenReject)
    },
    showDownload() {
      const origin = window.location.origin
      if (origin.includes('mol-electron')) {
        return true
      }
      return (
        this.isInnerIPFn() ||
        [88, 89, 90, 115, 116].includes(this.details.formId)
      )
    },

    // ============================================================
    // 流程节点相关
    // ============================================================
    uniqueProcessActionList() {
      if (!this.processActionList) return []
      return this.processActionList.filter(
        (v, index, self) =>
          self.findIndex(
            (t) =>
              t.id === v.id &&
              t.type === v.type &&
              t.result === v.result &&
              t.actor === v.actor &&
              t.actionId === v.actionId
          ) === index
      )
    },
    showRevokedBtn() {
      return function (name) {
        return name === (this.userInfoCache && this.userInfoCache.fullName)
      }
    },
    showSelfSelectMultiple() {
      return function (item) {
        let multiple = false
        if (item.props && item.props.assignedType === 'ASSIGN_USER') {
          multiple = item.props.assignedUser.length > 1
        } else {
          multiple = item.props.selfSelect && item.props.selfSelect.multiple
        }
        return multiple
          ? this.countersignModeMap[item.props && item.props.mode]
          : ''
      }
    },
    actionStatusIcon() {
      return function (item) {
        if (['complete', 'agree', 'CC'].includes(item.result)) {
          return 'el-icon-success success'
        } else if (item.result === 'pending') {
          return this.details.state === 1 ? 'el-icon-time pending' : ''
        } else if (item.result === 'processing') {
          return 'el-icon-loading'
        } else if (item.result === 'refuse') {
          return 'el-icon-error reject'
        } else if (item.result === 'close') {
          return 'el-icon-circle-close close'
        }
        return ''
      }
    },
    actionStatusTitle() {
      return function (item) {
        const resultHandlers = {
          complete: () => (item.type === 'ROOT' ? '重提' : item.type === 'TRIGGER' ? '已触发' : '已同意'),
          agree: () => (item.type === 'ROOT' ? '重提' : item.type === 'TRIGGER' ? '已触发' : '已同意'),
          pending: () => (this.details.state === 1 ? '等待中...' : '无需审批'),
          countersign: () => `${item.countersignedUser && item.countersignedUser.length}人`,
          dynamicAddAuditor: () => `${item.params && item.params.afterCurrentTask ? '后' : '前'}加签`,
          delegate: () => `委托给<a>${item.params && item.params.delegateTo && item.params.delegateTo.fullName}</a>`,
          rollback: () => {
            const lastNodeItems = this.processOriginNodeList.find((v) => v.id === item.params.toNodeId)
            const fromNodeItems = this.processOriginNodeList.find((v) => v.id === item.params.fromNodeId)
            const auditers =
              (this.details.variables && this.details.variables[`${item.params.toNodeId}_userFullNames`]) || []
            const formNodeName =
              (item.params && item.params.params && item.params.params.fromNodeName) ||
              (fromNodeItems && fromNodeItems.name) ||
              ''
            const lastAuditersItem = this.processActionList
              .filter((v) => v.id === item.params.fromNodeId)
              .pop()
            const lastAuditers =
              (lastAuditersItem && lastAuditersItem.actor) || ''
            const fromNodeActor =
              (item.params && item.params.params && item.params.params.fromNodeActor) ||
              lastAuditers ||
              ''
            return lastNodeItems
              ? `从节点<a>【${formNodeName}-${fromNodeActor}】</a>退回到节点<a>【${lastNodeItems && lastNodeItems.name}-<a-tag>${auditers}</a-tag>】</a>`
              : '退回节点'
          },
          processing: () => '处理中',
          withdraw: () => '已撤销',
          cc: () => '已抄送',
          save: () => '保存数据',
          taskHandover: () => '任务交接',
          close: () => '流程关闭',
          selfSelect: () => '请选择'
        }
        const handler = resultHandlers[item.result]
        return handler ? handler() : '已拒绝'
      }
    },
    stateIconColor() {
      return function (type) {
        const stateMap = {
          '-1': ['#808080', 'el-icon-refresh-left'],
          0: ['#ccc', 'el-icon-document'],
          1: ['#1890ff', 'el-icon-loading'],
          2: ['#f56c6c', 'el-icon-error'],
          3: ['#35b881', 'el-icon-success'],
          4: ['#808080', 'el-icon-document']
        }
        if (Number.isInteger(this.details.state)) {
          return stateMap[this.details.state][type]
        }
        return stateMap[0][type]
      }
    },
    nextHandler() {
      if (
        this.processActionList.length &&
        this.processActionList.some((v) => v.result === 'processing')
      ) {
        return (
          '等待' +
          (this.processActionList.find((v) => v.result === 'processing').actor || '') +
          '处理'
        )
      }
      return ''
    },
    judgeIsAuditable() {
      if (!this.processActionList.length) return false
      const currentNodeProcess = this.processActionList.find(
        (v) =>
          v.id === this.details.activeNodeId &&
          ['pending', 'processing', 'countersign'].includes(v.result)
      )
      const currentUser = this.userInfoCache.fullName
      if (currentNodeProcess) {
        if (['pending', 'processing'].includes(currentNodeProcess.result)) {
          return (currentNodeProcess && currentNodeProcess.actor) === currentUser
        } else if (currentNodeProcess.result === 'countersign') {
          const countersignedUser = currentNodeProcess.countersignedUser
          const filterPendingCountersignedUser = countersignedUser.find(
            (item) => ['pending', 'processing'].includes(item.result)
          )
          return (currentNodeProcess && currentNodeProcess.props && currentNodeProcess.props.mode) === 'AND'
            ? countersignedUser.some((v) => v.name === currentUser)
            : (filterPendingCountersignedUser && filterPendingCountersignedUser.name) === currentUser
        }
      }
      return false
    },

    // ============================================================
    // 数据展示/格式化
    // ============================================================
    getFilteredTableHeaders() {
      return (item) => {
        const headers = this.getTableHeaders(item) || []
        return headers.filter(
          (v) => !this.excludeKeywords.some((keyword) => v.key.includes(keyword))
        )
      }
    },
    filterImgGroup() {
      return function (item, type) {
        if (item.params && item.params.attachFile && item.params.attachFile.length) {
          const attachFile = item.params.attachFile
          const imgTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
          if (type === 1) {
            return attachFile.filter((v) => imgTypes.includes(v.fileName.split('.').pop()))
          } else {
            return attachFile.filter((v) => !imgTypes.includes(v.fileName.split('.').pop()))
          }
        }
        return []
      }
    },
    formatFileSize(){
      return function (byte) {
        if (byte < 1024 * 1024) {
          return (byte / 1024).toFixed(2) + 'KB'
        } else {
          return (byte / 1024 / 1024).toFixed(2) + 'MB'
        }      }
    },
    formatFileList() {
      return function (item) {
        return (item.extValue && JSON.parse(item.extValue)) || []
      }
    },
    splitImg() {
      return function (item) {
        return item.extValue ? item.extValue.split(',') : []
      }
    },
    fullPath() {
      return function (val) {
        return process.env.VUE_APP_BASE_API + '/fileinfo/' + val
      }
    },
    formatFinishTimeLabel() {
      return function (item) {
        if (this.details.state !== 1 && item.result === 'pending') {
          return ''
        }
        if (
          item.result === 'processing' ||
          (item.result === 'countersign' &&
            item.countersignedUser.map((v) => v.result === 'processing'))
        ) {
          return '处理中'
        }
        return item.finishTime
      }
    },
    approverSelectNodeName() {
      return function (item) {
        const nodeId = item && item.approverSelect && item.approverSelect.nodeId
        if (nodeId) {
          const node = this.processOriginNodeList.find((v) => v.id === nodeId)
          return node && node.name
        }
        return ''
      }
    },
    isDynamicAssignment() {
      return function (item) {
        return (
          !item.actor &&
          item.props &&
          item.props.approverSelect &&
          item.props.approverSelect.nodeId
        )
      }
    },

    // ============================================================
    // 表单校验规则
    // ============================================================
    rules() {
      const rules = {}
      this.dynamicActiveNodeItems.forEach((item, index) => {
        rules[`variables.${item.id}_users`] = [
          {
            required: true,
            message: `请指定节点【${item.name}】审批人`,
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error(`请指定节点【${item.name}】审批人`))
              } else {
                callback()
              }
            }
          }
        ]
      })
      return rules
    }
  },

  watch: {
    'form.formData': {
      handler(newVal) {
        const editableVariables = {}
        this.editableComponents
          .filter((item) => item.bizAlias)
          .forEach((item) => {
            editableVariables[item.bizAlias] = newVal[item.id]
          })
        if (
          this.details.bpmn &&
          Object.values(editableVariables).some((value) => value)
        ) {
          this.setProcessActionList()
          this.getApprovalnodeprediction(editableVariables)
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    computedTimeSpent,

    // ============================================================
    // 数据格式化方法
    // ============================================================

    /**
     * 解析固件版本信息（用于表格列 bizAlias=firmwareVersionInfo 的展示）
     * 返回数组，每项包含 versionInfo、version、processor、processorLabel、fileName、svnUrl
     */
    parseFirmwareVersionInfo(value) {
      const PROCESSOR_MAP = {
        metering: '计量芯',
        communication: '通讯芯',
        display: '显示芯',
        control: '控制芯'
      }
      try {
        if (!value) return []
        const data = typeof value === 'string' ? JSON.parse(value) : value
        const list = Array.isArray(data) ? data : [data]
        return list.map((item) => ({
          ...item,
          processorLabel: PROCESSOR_MAP[item.processor] || item.processor || ''
        }))
      } catch (e) {
        return []
      }
    },

    /**
     * 解析值为数组（兼容 JSON 字符串和原始数组）
     */
    formatArray(val) {
      if (!val) return
      return typeof val === 'string' ? JSON.parse(val) : val
    },

    /**
     * 获取人员简称（取名字后两位）
     */
    getShortName(name) {
      if (name) {
        return name.length > 2 ? name.substring(1, 3) : name
      }
      return '**'
    },

    /**
     * 获取表格表头信息
     */
    getTableHeaders(item) {
      if (!item.value) return []
      try {
        const parsed = JSON.parse(item.value)
        return (parsed && parsed[0] && parsed[0].rowValue) || []
      } catch (e) {
        return []
      }
    },

    /**
     * 获取表格列值（含 bizAlias 映射转换）
     */
    getColumnValue(record, key) {
      const column =
        record &&
        record.rowValue &&
        record.rowValue.find((col) => col.key === key)

      // "是否"类型字段的布尔转换
      if (column && column.label && column.label.includes('是否')) {
        return column
          ? column.value === '1' ? '是' : column.value === '0' ? '否' : column.value
          : ''
      }

      // bizAlias 映射转换
      const bizAliasMap = {
        fuseState: this.fuseStateMap,
        itemMasterType: this.itemMasterTypeMap,
        itemFormAttribute: this.itemFormAttributeMap,
        category: this.categoryMap,
        softwareFileType: this.softwareFileTypeMap
      }
      if (column && column.bizAlias && bizAliasMap[column.bizAlias]) {
        return bizAliasMap[column.bizAlias][column.value] || column.value
      }

      // 复杂字段类型：需要 JSON 解析
      const complexFieldTypes = [
        'DepartmentField', 'InnerContactField', 'DDAttachment',
        'DDPhotoField', 'DDateRangeField', 'DDMultiSelectField'
      ]
      if (complexFieldTypes.some((type) => column && column.key && column.key.includes(type))) {
        if (column.value) {
          return typeof column.value === 'string' ? JSON.parse(column.value) : column.value
        }
        return []
      }

      return column ? column.value : ''
    },

    /**
     * 判断字段是否为金额字段
     */
    isAmountField(item) {
      return AMOUNT_KEYWORDS.some(
        (keyword) =>
          item.name &&
          item.name.includes(keyword) &&
          !item.name.includes('币种') &&
          !item.name.includes('类型')
      )
    },

    /**
     * 获取带大写金额的显示值
     */
    getAmountDisplayValue(item) {
      const baseValue = item.value
      if (
        [88, 115, 116].includes(this.details.formId) &&
        this.isAmountField(item) &&
        item.value &&
        !isNaN(parseFloat(item.value))
      ) {
        const chineseAmount = this.digitUppercase(item.value)
        return `${baseValue} (大写: ${chineseAmount})`
      }
      return baseValue
    },

    /**
     * 判断表格字段是否为金额字段
     */
    isTableAmountField(column) {
      return AMOUNT_KEYWORDS.some(
        (keyword) =>
          column.label &&
          column.label.includes(keyword) &&
          !column.label.includes('币种') &&
          !column.label.includes('类型')
      )
    },

    /**
     * 获取表格中的金额显示值
     */
    getTableAmountDisplayValue(record, column) {
      return this.getColumnValue(record, column.key)
    },

    /**
     * 复制成功回调
     */
    onCopy() {
      this.$message.success('内容已复制到剪切板！')
    },

    /**
     * 刷新图片预览
     */
    previewImage() {
      this.$nextTick(() => {
        this.$previewRefresh()
      })
    },

    // ============================================================
    // 文档资料相关方法
    // ============================================================

    /**
     * 获取文档标题
     */
    getDocumentTitle(componentType) {
      const titleMap = {
        DocumentInformationForm: '文档资料信息',
        DocumentInformationNewForm: '文档资料信息',
        SaleInformationForm: '销售信息文档',
        FunctionalTestingInformationForm: '功能测试信息文档'
      }
      return titleMap[componentType] || '文档资料信息'
    },

    /**
     * 获取文档资料详情数据
     */
    getDocumentDetails(item) {
      try {
        if (!item.extValue) return []

        // 如果是汇总文本，从原始表单数据获取
        if (typeof item.extValue === 'string' && item.extValue.includes('已填写')) {
          return this.getDocumentDetailsFromFormData(item)
        }

        let extValue
        try {
          extValue = JSON.parse(item.extValue)
        } catch (e) {
          return this.getDocumentDetailsFromFormData(item)
        }

        const documentTypes = getDocumentTypesByComponentType(item.componentType, this)

        if (Array.isArray(extValue)) {
          return parseDocumentDetailsFromArray(extValue, documentTypes)
        }

        // 兼容旧的对象格式
        const dataSource = Array.isArray(extValue) ? extValue[0] : extValue
        if (!dataSource || typeof dataSource !== 'object') return []

        return documentTypes.map((docType) => ({
          id: docType.id,
          name: docType.name,
          fileName: dataSource[`${docType.id}_fileName`] || '',
          svnPath: dataSource[`${docType.id}_svnPath`] || ''
        }))
      } catch (error) {
        console.error('解析文档资料数据失败:', error)
        return []
      }
    },

    /**
     * 从原始表单数据中获取文档详情（当 extValue 是汇总文本时使用）
     */
    getDocumentDetailsFromFormData(item) {
      try {
        const documentTypes = getDocumentTypesByComponentType(item.componentType, this)
        const formData = this.details.formData || []

        return documentTypes.map((docType) => {
          const formField = formData.find(
            (field) =>
              field.id === docType.id ||
              field.bizAlias === docType.id ||
              field.id.includes(docType.id)
          )

          if (formField) {
            let fileName = ''
            let svnPath = ''
            if (formField.extValue) {
              try {
                const parsed = JSON.parse(formField.extValue)
                fileName = parsed.fileName || ''
                svnPath = parsed.svnPath || ''
              } catch (e) {
                fileName = formField.value || ''
              }
            } else if (formField.value) {
              fileName = formField.value
            }
            return { id: docType.id, name: docType.name, fileName, svnPath }
          }
          return { id: docType.id, name: docType.name, fileName: '', svnPath: '' }
        })
      } catch (error) {
        console.error('从表单数据获取文档详情失败:', error)
        return []
      }
    },

    // ============================================================
    // 审批流程操作方法
    // ============================================================

    /**
     * 撤销评论
     */
    // revokedAction(item) {
    //   this.$confirm({
    //     title: '提示',
    //     content: '确定要撤回这条记录嘛？',
    //     okText: '确认',
    //     cancelText: '取消',
    //     centered: true,
    //     onOk: () => {
    //       postAction('/workflow/forminstance/deleteaction', {
    //         actionId: item.actionId
    //       }).then((res) => {
    //         if (res.code === 200) {
    //           this.$message.success('撤销成功')
    //           this.getApprovalInstanceDetails()
    //         }
    //       })
    //     }
    //   })
    // },

    /**
     * 标记OA任务已读
     */
    // markRead(taskId) {
    //   postAction('/workflow/forminstance/maketaskread', { taskId }).then(() => {})
    // },

    /**
     * 设置流程动作列表
     */
    setProcessActionList() {
      const actionList = this.buildActionList(
        this.fullApprovalActionList,
        this.reorganizeConditions(this.initailProcessList)
      )
      if (this.details.state === 1) {
        this.handlePendingApproval(
          this.initailProcessList,
          this.details.variables,
          this.fullApprovalActionList,
          actionList
        )
      } 
      // console.log("🚀 ~ this.fullApprovalActionList:", this.fullApprovalActionList)
      // console.log("🚀 ~ this.initailProcessList:", this.initailProcessList)

      this.processActionList = actionList
      // console.log("🚀 ~   this.processActionList:",   this.processActionList)
    },

    /**
     * 构建动作列表
     */
    buildActionList(actions, process) {
      return actions
        .map((ac) => {
          if (ac.action === 'submit') {
            return {
              id: 'root',
              type: 'ROOT',
              name: '发起人',
              actor: ac.actorFullName,
              actionId: ac.actionId,
              result: 'complete',
              finishTime: ac.executionTime
            }
          }

          const processItem = process.find((p) => p.id === ac.params.nodeId)
          const nodeData = {
            actor: ac.actorFullName,
            actionId: ac.actionId,
            result: this.judgeStatusByActionType(ac),
            finishTime: ac.executionTime,
            startTime: ac.params.taskStartTime || null,
            comment: ac.params.comment,
            formData: ac.params.formData,
            params: ac.params
          }

          if (processItem) {
            return {
              ...processItem,
              name: this.showNodeName(processItem, ac),
              ...nodeData
            }
          }
          return {
            name: this.showNodeName({}, ac),
            ...nodeData,
            ccUsers:
              ac.action === 'cc'
                ? (ac.params &&
                    ac.params.assignedUser &&
                    ac.params.assignedUser.map((item) => ({
                      ...item,
                      result: 'complete'
                    }))) || null
                : null
          }
        })
        .filter(Boolean)
    },

    /**
     * 处理待审批节点
     */
    handlePendingApproval(process, variables, actions, actionList) {
      const currentNodeIdIndex = process.findIndex(
        (v) => v.id === this.details.activeNodeId
      )
      if (currentNodeIdIndex === -1) return

      process.slice(currentNodeIdIndex).forEach((item) => {
        if (item.props) {
          actionList.push(this.processApprovalNode(item, actions))
        }
      })
    },

    /**
     * 处理多人审批节点
     */
    handleMultiApproval(item, assignedUsers, actions, actionList) {
      const lastRollbackNodeIndex = this.getLastRollbackIndex(actions)
      const separationActions =
        lastRollbackNodeIndex !== -1
          ? actions.slice(lastRollbackNodeIndex + 1)
          : actions

      if (assignedUsers.length > 1) {
        if (item.props.mode === 'NEXT') {
          assignedUsers.forEach((user) => {
            const lastActionIsRollback =
              actions.length > 0 && actions[actions.length - 1].action === 'rollback'
            const hasUserApproved = separationActions.some(
              (v) =>
                v.params &&
                v.action === 'audit' &&
                v.params.nodeId === item.id &&
                v.actorFullName === user
            )
            if (lastActionIsRollback || !hasUserApproved) {
              actionList.push({
                ...item,
                actor: user,
                result: 'pending',
                finishTime: '等待中',
                comment: null,
                formData: null
              })
            }
          })
        } else {
          actionList.push(this._buildCountersignNode(item, assignedUsers, separationActions))
        }
      } else {
        actionList.push({
          ...item,
          actor: assignedUsers[0],
          result: this.judgeAduitActionStatus(item, assignedUsers[0], null),
          finishTime: '等待中',
          comment: null,
          formData: null
        })
      }
    },

    /**
     * 处理抄送结果
     */
    handleCCResults(process, variables, actionList) {
      const ccNode = process.find((v) => v.type === 'CC')
      if (ccNode) {
        actionList.push({
          ...ccNode,
          actor: '已抄送',
          result: 'CC',
          ccUsers: this.getCcUserList('complete'),
          finishTime: null,
          comment: null
        })
      }
    },

    /**
     * 处理审批节点展示（已合并 NEXT 与非 NEXT 分支的重复代码）
     */
    processApprovalNode(item, actions = null) {
      return this._processApprovalNodeBase(item, actions)
    },

    /**
     * processApprovalNode 基础实现（供组件覆写时复用）
     */
    _processApprovalNodeBase(item, actions = null) {
      const assignedUsers =
        (item.props &&
          item.props.assignedUser &&
          item.props.assignedUser.map((v) => v.name)) ||
        []
      const actor =
        this.details.variables[`${item.id}_userFullNames`] || assignedUsers
      actions = actions || this.details.actions || []

      // 抄送节点
      if (item.type === 'CC') {
        const isPending = this.details.state === 1
        return {
          ...item,
          actor: '流程结果将抄送给他们',
          result: isPending ? 'pending' : 'complete',
          finishTime: isPending ? '待抄送' : null,
          ccUsers: this.getCcUserList(isPending ? 'pending' : 'complete'),
          comment: null,
          formData: null
        }
      }

      // 多人审批（会签/或签）
      if (actor.length > 1) {
        return this._buildCountersignNode(item, actor, actions)
      }

      // 单人审批
      return {
        ...item,
        actor: actor[0],
        result: this.judgeAduitActionStatus(item, actor[0], null),
        finishTime: '等待中',
        comment: null,
        formData: null
      }
    },

    /**
     * 构建会签/或签节点数据（消除 processApprovalNode 中的重复代码）
     */
    _buildCountersignNode(item, actors, actions) {
      return {
        ...item,
        actor:
          (this.countersignModeMap &&
            this.countersignModeMap[item.props.mode]) ||
          '多人审批',
        result: 'countersign',
        finishTime: '等待中',
        countersignedUser: actors.map((user) => {
          const actionItem = (Array.isArray(actions) ? actions : []).find(
            (v) =>
              v.action === 'audit' &&
              v.actorFullName === user &&
              v.params &&
              v.params.nodeId === item.id
          )
          return {
            name: user,
            result: this.judgeAduitActionStatus(item, user, actionItem),
            comment: actionItem ? actionItem.params.comment : null,
            formData: actionItem ? actionItem.params.formData : null,
            finishTime: actionItem ? actionItem.executionTime : null,
            startTime: actionItem ? actionItem.params.taskStartTime || null : null
          }
        }),
        comment: null,
        formData: null
      }
    },

    /**
     * 根据动作类型判断状态
     */
    judgeStatusByActionType(item) {
      if (item.action === 'audit') {
        return item.params.passed ? 'agree' : 'refuse'
      }
      return item.action
    },

    /**
     * 获取节点名称
     */
    showNodeName(proItem, ac) {
      const nameMap = {
        audit: () =>
          (ac.params && ac.params.nodeId) === 'root_hidden'
            ? '发起人'
            : proItem.name || '审批人',
        addAttachment: () => '添加附件',
        delegate: () => '委托人',
        rollback: () => '退回流程',
        dynamicAddAuditor: () => proItem.name || '加签人',
        withdraw: () => '撤销人',
        cc: () => '抄送人',
        save: () => '保存'
      }
      const handler = nameMap[ac.action]
      return handler ? handler() : ''
    },

    /**
     * 判断审批动作状态
     */
    judgeAduitActionStatus(item, user, actionItem) {
      return actionItem
        ? actionItem.params.passed ? 'agree' : 'refuse'
        : this.details.variables[`${item.id}_${user}_read`]
          ? 'processing'
          : 'pending'
    },

    /**
     * 获取最后一次退回操作的索引
     */
    getLastRollbackIndex(actions) {
      let lastRollbackIndex = -1
      let lastDynamicAddAuditorIndex = -1
      let lastAuditRefuseIndex = -1
      for (let i = actions.length - 1; i >= 0; i--) {
        if (actions[i].action === 'audit' && actions[i].params && !actions[i].params.passed) {
          lastAuditRefuseIndex = i
          break
        }
        if (actions[i].action === 'rollback') {
          lastRollbackIndex = i
          break
        }
      }
      if (lastAuditRefuseIndex !== -1) return lastAuditRefuseIndex
      return lastRollbackIndex !== -1 ? lastRollbackIndex : lastDynamicAddAuditorIndex
    },

    /**
     * 获取抄送人列表
     */
    getCcUserList(result) {
      if (this.details.ccUser) {
        return this.details.ccUser.map((user) => ({ ...user, result }))
      }
      return []
    },

    /**
     * 重新组织条件节点
     */
    reorganizeConditions(data) {
      if (!data || !Array.isArray(data)) return []
      const result = []
      const processedIds = new Set()
      function processNode(node, level = 0) {
        if (!node || processedIds.has(node.id)) return
        processedIds.add(node.id)
        result.push({ ...node, level })
        if (node.children) {
          processNode(node.children, level + 1)
        }
      }
      data.forEach((node) => processNode(node))
      return result
    },

    // ============================================================
    // 审批详情获取
    // ============================================================

    /**
     * 获取审批实例详情
     */
     
    // ============================================================
    // 表单权限和组件处理
    // ============================================================

    /**
     * 处理表单权限和组件
     */
    processFormPermissions(process) {
      const currentNodeProcess = process.find(
        (v) => v.id === this.details.activeNodeId
      )
      const formComponents = processFormData(this.details.formComponents) || []

      if (currentNodeProcess) {
        const formPerms =
          (currentNodeProcess.props &&
            currentNodeProcess.props.formPerms) ||
          []
        this.details.formData.forEach((item) => {
          const formPermsItem = formPerms.find((v) => v.id === item.id)
          this.$set(item, 'perm', formPermsItem ? formPermsItem.perm : 'R')
        })
      }

      if (formComponents.length && this.details.formData.length) {
        this.details.formData.forEach((item) => {
          const formComponentItem = formComponents.find(
            (v) => v.props.componentId === item.id
          )
          this.$set(
            item,
            'props',
            formComponentItem ? formComponentItem.props : {}
          )
        })
      }

      this.editableComponents = this.details.formData
        .filter((item) => item.perm === 'E')
        .map((item) => ({
          ...splitPropsParams(item),
          props: {
            ...item.props,
            ...item.props.extendProps,
            options: ['DDSelectField', 'DDMultiSelectField'].includes(
              item.componentType
            )
              ? (item.props.options &&
                  item.props.options.map((v) => v.value))
              : undefined
          }
        }))

      this.details.formData = this.details.formData.filter(
        (item) => item.perm !== 'E' || item.perm !== 'H'
      )
    },

    /**
     * 获取可编辑组件的表单值
     */
    getFormDataValue() {
      this.$set(this.form, 'formData', {})
      if (this.editableComponents.length && this.form.taskId) {
        if (this.details.formData && this.details.formData.length > 0) {
          this.details.formData.forEach((item) => {
            if (this.editableComponents.some((v) => v.id === item.id)) {
              this.$set(this.form.formData, item.id, setFormValue(item))
            }
          })
        }
      }
    },

    // ============================================================
    // 审批节点预测
    // ============================================================

    /**
     * 获取审批节点预测
     */
    // async getApprovalnodeprediction(variables = {}) {
    //   let params = {
    //     bpmn: this.details.bpmn,
    //     variables: {}
    //   }

    //   const filterBizAlias =
    //     (this.details.formData &&
    //       this.details.formData.filter((v) => v.bizAlias)) ||
    //     []
    //   filterBizAlias.forEach((item) => {
    //     params.variables[item.bizAlias] = item.value || ''
    //   })

    //   params.variables = { ...params.variables, ...variables }

    //   if (this.processOriginNodeList.some((v) => v.type === 'CONDITIONS')) {
    //     const res = await postAction(
    //       '/workflow/forminstance/approvalnodeprediction',
    //       params
    //     )
    //     const nodepredictDetails = res.data || {}
    //     this.sequenceFlowIds =
    //       (nodepredictDetails.variables &&
    //         nodepredictDetails.variables.sequenceFlowIds) ||
    //       []
    //   } else {
    //     const currentNodeIdIndex = this.processOriginNodeList.findIndex(
    //       (v) => v.id === this.details.activeNodeId
    //     )
    //     this.toProcessNodeList = this.processOriginNodeList.slice(
    //       0,
    //       currentNodeIdIndex
    //     )
    //     this.dynamicActiveNodeItems = this.getDynamicActiveNodeItems(
    //       this.processOriginNodeList
    //     )
    //   }
    // },

    // ============================================================
    // 审批操作
    // ============================================================

    /**
     * 保存表单数据
     */
    saveHandle() {
      let params = { ...this.form }
      if (this.editableComponents.length && this.form.formData) {
        params.formData = Object.keys(this.form.formData)
          .filter((key) => {
            const formItem = this.details.formData.find((v) => v.id === key)
            return (
              formItem &&
              formItem.value !==
                formateValue(this.form.formData, key, this.editableComponents)
            )
          })
          .map((key) => {
            const editable = this.editableComponents.find(
              (v) => v.id === key
            )
            return {
              name: editable && editable.title,
              id: key,
              value:
                formateValue(
                  this.form.formData,
                  key,
                  this.editableComponents
                ) || '',
              extValue:
                typeof this.form.formData[key] === 'object'
                  ? JSON.stringify(this.form.formData[key])
                  : this.form.formData[key] || ''
            }
          })
      }

      this.saveLoading = true
      // postAction('/workflow/forminstance/savedata', params)
      //   .then((res) => {
      //     if (res.code === 200) {
      //       this.$message.success('保存数据成功')
      //       this.getApprovalInstanceDetails()
      //     }
      //   })
      //   .finally(() => {
      //     this.btnLoading = false
      //     this.saveLoading = false
      //   })
    },

    /**
     * 审批操作（同意/驳回）
     */
    auditHandle(passed) {
      let params = { ...this.form, passed }
      if (this.editableComponents.length && passed) {
        if (this.form.formData) {
          params.formData = Object.keys(this.form.formData)
            .filter((key) => {
              const formItem = this.details.formData.find((v) => v.id === key)
              return (
                formItem &&
                formItem.value !==
                  formateValue(this.form.formData, key, this.editableComponents)
              )
            })
            .map((key) => {
              const editable = this.editableComponents.find(
                (v) => v.id === key
              )
              return {
                name: editable && editable.title,
                id: key,
                value:
                  formateValue(
                    this.form.formData,
                    key,
                    this.editableComponents
                  ) || '',
                extValue:
                  typeof this.form.formData[key] === 'object'
                    ? JSON.stringify(this.form.formData[key])
                    : this.form.formData[key] || ''
              }
            })
        }

        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$refs.dyForm.validate((valid) => {
              if (valid) {
                this.requestCompleteTask(passed, params)
              } else {
                this.$message.warning('请注意页面存在审批人未指定！')
              }
            })
          } else {
            this.$message.warning('请注意页面存在必填项未填写！')
          }
        })
      } else {
        params.formData = undefined
        if (passed) {
          this.$refs.dyForm.validate((valid) => {
            if (valid) {
              this.requestCompleteTask(passed, params)
            } else {
              this.$message.warning('请注意页面存在审批人未指定！')
            }
          })
        } else {
          this.$confirm({
            title: '确定驳回吗?',
            content: '驳回后流程将终止',
            centered: true,
            onOk: () => {
              this.requestCompleteTask(passed, params)
            }
          })
        }
      }
    },

    /**
     * 请求完成审批任务
     */
    // requestCompleteTask(passed, params) {
    //   this.btnLoading = true
    //   if (passed) {
    //     this.argeeLoading = true
    //   } else {
    //     this.refuseLoading = true
    //   }

    //   postAction('/workflow/forminstance/completetask', params)
    //     .then((res) => {
    //       if (res.code === 200) {
    //         this.$message.success('操作成功')
    //         this.form = {}
    //         this.$emit('ok')
    //         this.getApprovalInstanceDetails()
    //         this.visible = false
    //       }
    //     })
    //     .finally(() => {
    //       this.btnLoading = false
    //       this.argeeLoading = false
    //       this.refuseLoading = false
    //     })
    // },

    // ============================================================
    // 动态审批人相关
    // ============================================================

    /**
     * 获取动态审批人节点
     */
    getDynamicActiveNodeItems(process) {
      const fullProcess = [...process, ...this.nextApprovalNode]
      return fullProcess.filter(
        (item) =>
          item.props &&
          item.props.approverSelect &&
          item.props.approverSelect.nodeId === this.details.activeNodeId &&
          (fullProcess.some((v) => v.type === 'CONDITIONS')
            ? this.sequenceFlowIds.includes(item.id)
            : true)
      )
    },

    /**
     * 分组动态审批人节点（含默认值处理）
     */
    groupDynamicActiveNodeItems() {
      this.dynamicActiveNodeItems = this.getDynamicActiveNodeItems(
        this.processOriginNodeList
      )
      this.dynamicActiveNodeItems.forEach((item, index) => {
        if (this.orginVariables[`${item.id}_userFullNames`]) {
          const userFullNames = this.orginVariables[`${item.id}_userFullNames`]
          const users = this.orginVariables[`${item.id}_users`]
          const assignedUser = userFullNames.map((v, i) => ({
            id: Date.now(),
            name: v,
            username: users[i],
            type: 'user'
          }))
          this.$set(item.props, 'assignedUser', assignedUser)
        }
      })
      this.dynamicAssigneeList = this.dynamicActiveNodeItems.map((v) => {
        if (
          v.props &&
          v.props.assignedType === 'SELF_SELECT' &&
          v.props.assignedUser &&
          v.props.assignedUser.length > 1
        ) {
          return []
        }
        return (v.props && v.props.assignedUser) || []
      })
      // 确保有默认值时正确设置 form.variables
      this.dynamicActiveNodeItems.forEach((item, index) => {
        if (this.dynamicAssigneeList[index] && this.dynamicAssigneeList[index].length > 0) {
          this.$set(
            this.form.variables,
            `${item.id}_users`,
            this.dynamicAssigneeList[index].map((user) => user.username)
          )
          this.$set(
            this.form.variables,
            `${item.id}_userFullNames`,
            this.dynamicAssigneeList[index].map((user) => user.name)
          )
        }
      })
    },

    /**
     * 更新审批人变量
     */
    updateVariables(index) {
      const item = this.dynamicActiveNodeItems[index]
      this.$set(
        this.form.variables,
        `${item.id}_users`,
        this.dynamicAssigneeList[index].map((user) => user.username)
      )
      this.$set(
        this.form.variables,
        `${item.id}_userFullNames`,
        this.dynamicAssigneeList[index].map((user) => user.name)
      )
    },

    /**
     * 添加审批人
     */
    handleAddUser(index) {
      this.activeSelectIndex = index
      const item = this.dynamicActiveNodeItems[index]
      this.selectedUserList = this.dynamicAssigneeList[index] || []
      this.selectedUserList.forEach((user) => {
        user.type_id = `${user.type}_${user.name}`
      })
      let ids = ''
      let candidateList = []
      if (item.props && item.props.assignedType === 'ROLE') {
        this.pickerType = 'role'
        ids = item.props.role.map((v) => v.id).join()
      } else if (item.props && item.props.assignedType === 'SELF_SELECT') {
        this.pickerType = 'user'
        candidateList = item.props.assignedUser || []
      } else {
        this.pickerType = 'user'
      }
      this.selfSelectMultiple =
        item.props &&
        item.props.selfSelect &&
        item.props.selfSelect.multiple
      this.$nextTick(() => {
        this.$refs.orgPicker.show(ids, candidateList)
      })
    },

    /**
     * 移除审批人
     */
    removeUser(user, index) {
      const filtered = this.dynamicAssigneeList[index].filter(
        (item) => item.id !== user.id
      )
      this.$set(this.dynamicAssigneeList, index, filtered)
      this.updateVariables(index)
    },

    /**
     * 选择审批人回调
     */
    selectedUser(data) {
      this.$set(this.dynamicAssigneeList, this.activeSelectIndex, data)
      this.updateVariables(this.activeSelectIndex)
    },

    // ============================================================
    // 表单数据构建
    // ============================================================

    /**
     * 构建表单数据参数的公共方法
     * @param {Array} targetComponents - 目标组件列表
     * @param {boolean} includeVariables - 是否包含变量处理
     * @returns {Object} 处理后的参数对象
     */
    buildFormDataParams(targetComponents, includeVariables = false) {
      let params = { ...this.form }

      if (targetComponents.length && this.form.formData) {
        const processedFormData = this.processDocumentInformationData()
        // 展开复合组件
        const expandedComponents = targetComponents.flatMap((comp) => {
          if (
            comp &&
            ['OrderReviewForm', 'StructuralInformationForm'].includes(comp.name) &&
            comp.props &&
            Array.isArray(comp.props.children)
          ) {
            return comp.props.children
          }
          return [comp]
        })

        const groupFormIds = [
          'DocumentInformationForm_groupForm',
          'SaleInformationForm_groupForm',
          'FunctionalTestingInformationForm_groupForm'
        ]

        params.formData =
          (Object.keys(processedFormData).length &&
            Object.keys(processedFormData)
              .filter((key) => expandedComponents.some((item) => item.id === key))
              .map((key) => {
                const fieldValue = processedFormData[key]
                const targetComponent = expandedComponents.find((v) => v.id === key)

                // 信息表单的聚合数据，直接使用
                if (
                  fieldValue &&
                  typeof fieldValue === 'object' &&
                  groupFormIds.includes(fieldValue.id)
                ) {
                  return {
                    name: targetComponent && targetComponent.title,
                    id: key,
                    value: fieldValue.value,
                    extValue: fieldValue.extValue,
                    bizAlias: fieldValue.bizAlias
                  }
                }

                return {
                  name: targetComponent && targetComponent.title,
                  id: key,
                  value: formateValue(
                    this.form.formData,
                    key,
                    expandedComponents,
                    this.filterOriginBizAlias
                  ),
                  extValue:
                    typeof this.form.formData[key] === 'object'
                      ? JSON.stringify(this.form.formData[key])
                      : this.form.formData[key],
                  bizAlias: targetComponent && targetComponent.bizAlias,
                  label: targetComponent && targetComponent.label
                }
              })) ||
          []
      } else {
        params.formData = []
      }

      if (includeVariables) {
        const editableVariables = {}
        targetComponents
          .filter((item) => item.bizAlias)
          .forEach((item) => {
            editableVariables[item.bizAlias] = this.form.formData[item.id]
          })
        if (
          this.details.bpmn &&
          Object.values(editableVariables).some((value) => value)
        ) {
          params.variables = Object.assign(params.variables, editableVariables)
        }
      }

      return params
    },

    /**
     * 处理所有信息表单数据
     */
    processDocumentInformationData() {
      const processedData = { ...this.form.formData }
      INFORMATION_FORM_CONFIGS.forEach((config) => {
        this.processInformationFormByConfig(processedData, config)
      })
      return processedData
    },

    /**
     * 通用信息表单处理方法（泛化 processDocumentInformationForm / processSaleInformationForm / processFunctionalTestingInformationForm）
     * @param {Object} processedData - 待处理的表单数据（会被直接修改）
     * @param {Object} config - 信息表单配置
     */
    processInformationFormByConfig(processedData, config) {
      // 1. 收集匹配前缀的字段并解析值
      const collectedFields = {}
      Object.keys(this.form.formData).forEach((key) => {
        if (key.includes(config.fieldPrefix)) {
          collectedFields[key] = parseFieldValue(this.form.formData[key])
          delete processedData[key]
        }
      })

      // 2. 查找对应的可编辑组件
      const formComponent = this.editableComponents.find((form) =>
        config.componentNames.includes(form.name)
      )

      if (!formComponent) return

      // 3. 获取文档类型定义
      const documentTypes = config.getDocumentTypes(formComponent.name, this)

      // 4. 生成子项数据
      const subItems = documentTypes.map((docType) => {
        const data = collectedFields[docType.id] || { fileName: '', svnPath: '' }
        return {
          id: docType.id,
          value: data.fileName || '',
          extValue: JSON.stringify({ fileName: data.fileName || '', svnPath: data.svnPath || '' })
        }
      })

      // 5. 计算已填写数量
      const filledCount = subItems.filter((item) => {
        const ext = JSON.parse(item.extValue)
        return ext.fileName || ext.svnPath
      }).length

      // 6. 写入汇总数据
      processedData[formComponent.id] = {
        id: config.groupFormId,
        value: `已填写 ${filledCount}/${documentTypes.length} 个${config.summaryLabel}`,
        extValue: JSON.stringify(subItems),
        bizAlias: config.bizAlias
      }
    }
  }
}
